// import { getStore, removeStore, setStore } from "@/util/store";
import {
  foodmac_orderv2ReserveGoodsPagelist,
  foodmac_orderv2ReserveGoodsMenutypelist,
  foodmac_orderv2ReserveGoodsSumgoods,
  foodmac_orderv2ReserveGoodsAddreservegoods,
  foodmac_orderv2ReserveGoodsUpdatereservegoods,
  foodmac_orderv2ReserveGoodsReservegoodsdetail,
  foodmac_orderv2ReserveGoodsUpdatereserve,
  foodmac_orderv2ReserveGoodsAddreservegoodsinfo
} from "@/api/hb-stock-manage/shopIndent";
// import { deepClone } from "@/util";
const shopIndent = {
    state: {
      shopIndentPageLoading: false, // 订货单列表loading
      shopIndentPageRecords: [], // 订货单列表
      shopIndentPageTotal: 0, // 订货单总数
      shopIndentReserveGoodsMenuTypeList:[], // 订货单详情分类列表
      shopIndentReserveGoodsSumGoodsData: {}, // 商品总价对象 
      shopIndentDetail: {}, // 门店订货单详情
      shopIndentReShowDetail: {}, // 新增/编辑订货单详情回显
    },
    actions: {
      // 订货单列表
      getReserveGoodsPageList ({ commit }, params) {
        commit('SET_SHOPINDENTPAGELOADING', true)
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsPagelist(params).then((res) => {
            commit('SET_SHOPINDENTPAGELIST', res.data.data)
            commit('SET_SHOPINDENTPAGELOADING', false)
            resolve(res.data.data)
          }).catch((error) => {
            commit('SET_SHOPINDENTPAGELOADING', false)
            reject(error)
          })
        })
      },
      // 获取订货单详情分类列表 
      getReserveGoodsMenuTypeList({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsMenutypelist(params).then((res) => {
            commit('SET_SHOPINDENTRESERVEGOODSMENUTYPELIST', res.data.data)
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 计算商品总价
      getReserveGoodsSumGoods({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsSumgoods(params).then((res) => {
            commit('SET_SHOPINDENTRESERVEGOODSSUMGOODSDATA', res.data.data)
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 新增订货单
      getReserveGoodsAddreservegoods({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsAddreservegoods(params).then((res) => {
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 编辑订货单
      getReserveGoodsUpdatereservegoods({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsUpdatereservegoods(params).then((res) => {
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 门店订货单详情
      getReserveGoodsDetail({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsReservegoodsdetail(params).then((res) => {
            commit('SET_SHOPINDENTDETAIL', res.data.data)
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 取消订货单、标记完成、总部备注
      getReserveGoodsUpdate({ commit }, params){
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsUpdatereserve(params).then((res) => {
            console.log(res.data, '----------res.data')
            if (res.data.success) {
              resolve()
            }
          }).catch((error) => {
            reject(error)
          })
        })
      },
      // 新增/编辑订货单回显
      getReserveGoodsAddReserveGoodsInfo ({ commit }, params) {
        return new Promise((resolve, reject) => {
          foodmac_orderv2ReserveGoodsAddreservegoodsinfo(params).then((res) => {
            commit('SET_SHOPINDENTRESHOWDETAIL', res.data.data)
            resolve(res.data.data)
          }).catch((error) => {
            reject(error)
          })
        })
      }
    },
    // 在线大小写转换: https://www.iamwawa.cn/daxiaoxie.html
    mutations: {
      SET_SHOPINDENTPAGELOADING:(state, shopIndentPageLoading)=>{
        state.shopIndentPageLoading = shopIndentPageLoading
      },
      SET_SHOPINDENTPAGELIST:(state, shopIndentPageList)=>{
        const { records, total } = shopIndentPageList
        state.shopIndentPageRecords = records
        state.shopIndentPageTotal = total
      },
      SET_SHOPINDENTRESERVEGOODSMENUTYPELIST:(state, shopIndentReserveGoodsMenuTypeList)=>{
        // 处理num
        console.log('SET_SHOPINDENTRESERVEGOODSMENUTYPELIST/1', shopIndentReserveGoodsMenuTypeList)
        const len = shopIndentReserveGoodsMenuTypeList.length
        for (let i = 0; i < len; i++) {
          const item = shopIndentReserveGoodsMenuTypeList[i]
          const goodsLen = item.goodsList.length
          for (let j = 0; j < goodsLen; j++) {
            item.num = item.num || 0
          }
        }
        console.log('SET_SHOPINDENTRESERVEGOODSMENUTYPELIST/2', shopIndentReserveGoodsMenuTypeList)
        state.shopIndentReserveGoodsMenuTypeList = shopIndentReserveGoodsMenuTypeList
      },
      SET_SHOPINDENTRESERVEGOODSSUMGOODSDATA:(state, shopIndentReserveGoodsSumGoodsData)=>{
        state.shopIndentReserveGoodsSumGoodsData = shopIndentReserveGoodsSumGoodsData
      },
      SET_SHOPINDENTDETAIL:(state, shopIndentDetail)=>{
        state.shopIndentDetail = shopIndentDetail
      },
      SET_SHOPINDENTRESHOWDETAIL:(state, shopIndentReShowDetail)=>{
        state.shopIndentReShowDetail = shopIndentReShowDetail
      }
    }
  };
  export default shopIndent